<template>
  <div>
    <v-pagination
      @input="changepage"
      v-model="page"
      :length="pagelength"
      :total-visible="7"
    ></v-pagination>

    <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 1,
    },
    limit: {
      default: 10,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      page: 1,
      pagetmp: '',
      offset: 1,
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
  },
  methods: {
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.page * vm.limit - vm.limit
        if (vm.page != 1) {
          vm.offset + 1
        }
        this.$emit('onChange', { limit: vm.limit, offset: vm.offset })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/Pagination.vue